import { render, staticRenderFns } from "./PaymentPaypalInputs.vue?vue&type=template&id=637a242a&"
import script from "./PaymentPaypalInputs.vue?vue&type=script&lang=ts&"
export * from "./PaymentPaypalInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports